"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconBlock = function IconBlock(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconBlocks', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("g", {
    id: "blocks",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }, _react.default.createElement("g", {
    id: "blocks-2"
  }, _react.default.createElement("path", {
    d: "M1.2,1.2 L1.2,3.3 L14.8,3.3 L14.8,1.2 L1.2,1.2 Z M1,0 L15,0 C15.5522847,-1.01453063e-16 16,0.44771525 16,1 L16,3.5 C16,4.05228475 15.5522847,4.5 15,4.5 L1,4.5 C0.44771525,4.5 6.76353751e-17,4.05228475 0,3.5 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle-Copy-2"
  }), _react.default.createElement("path", {
    d: "M1.2,6.95 L1.2,9.05 L14.8,9.05 L14.8,6.95 L1.2,6.95 Z M1,5.75 L15,5.75 C15.5522847,5.75 16,6.19771525 16,6.75 L16,9.25 C16,9.80228475 15.5522847,10.25 15,10.25 L1,10.25 C0.44771525,10.25 6.76353751e-17,9.80228475 0,9.25 L0,6.75 C-6.76353751e-17,6.19771525 0.44771525,5.75 1,5.75 Z",
    id: "Rectangle-Copy-3"
  }), _react.default.createElement("path", {
    d: "M1.2,14.8 L14.8,14.8 L14.8,12.7 L1.2,12.7 L1.2,14.8 Z M1,11.5 L15,11.5 C15.5522847,11.5 16,11.9477153 16,12.5 L16,15 C16,15.5522847 15.5522847,16 15,16 L1,16 C0.44771525,16 6.76353751e-17,15.5522847 0,15 L0,12.5 C-6.76353751e-17,11.9477153 0.44771525,11.5 1,11.5 Z",
    id: "Rectangle-Copy-4"
  })))));
};

var _default = IconBlock;
exports.default = _default;